<template>
  <div class="game-container">
    <h1>吸血鬼幸存者 - MyGO!!!!!版</h1>
    <div class="game-info">
      <p>当前角色: {{ characterName }}</p>
      <p>波次: {{ wave }}</p>
      <p>得分: {{ score }}</p>
      <p>金币: {{ gold }}</p>
      <p>等级: {{ player.level }}</p>
      <p>经验: {{ player.exp }}/{{ expToNextLevel }}</p>
      <p>生命值: {{ playerHp }}/{{ playerMaxHp }}</p>
    </div>
    <div class="game-controls">
      <a-button type="primary" @click="openShop">商店</a-button>
      <a-button type="default" @click="backToMenu">返回菜单</a-button>
    </div>
    <div class="game-canvas">
      <canvas ref="gameCanvas" width="800" height="600"></canvas>
    </div>
    
    <!-- 商店弹窗 -->
    <div v-if="showShop" class="shop-overlay">
      <div class="shop-modal">
        <Shop 
          :initial-gold="gold" 
          :initial-level="player.level" 
          :initial-exp="player.exp"
          @close="closeShop"
          @purchase="handlePurchase"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, reactive, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Shop from './Shop.vue';

// 导入角色图片
import chisatoImage from '../assets/characters/chisato.svg';
import mukuImage from '../assets/characters/muku.svg';

export default {
  name: 'Game',
  components: {
    Shop
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const gameCanvas = ref(null);
    const showShop = ref(false);
    let ctx = null;
    
    // 游戏状态
    const characterId = ref(route.query.character || 'chisato');
    const characterName = ref('');
    const wave = ref(1);
    const score = ref(0);
    const gold = ref(0); // 金币
    
    // 玩家属性
    const playerHp = ref(100);
    const playerMaxHp = ref(100);
    
    // 玩家对象
    const player = reactive({
      x: 400,
      y: 300,
      radius: 20,
      speed: 5,
      color: '#409EFF',
      exp: 0,
      level: 1,
      damage: 10, // 子弹伤害
      fireRate: 0.1 // 攻击速度
    });
    
    // 计算升级所需经验
    const expToNextLevel = computed(() => {
      return player.level * 100;
    });
    
    // 游戏对象
    const enemies = reactive([]);
    const bullets = reactive([]);
    const powerUps = reactive([]);
    const bloodStains = reactive([]); // 血迹对象数组
    
    // 玩家升级
    const levelUp = () => {
      player.level++;
      player.exp = 0;
      // 升级时增加最大生命值
      playerMaxHp.value += 10;
      playerHp.value = playerMaxHp.value;
      // 增加金币
      gold.value += 10;
    };
    
    // 设置角色名称
    const setCharacterName = () => {
      if (characterId.value === 'chisato') {
        characterName.value = '千早爱音';
        player.color = '#FF6B6B'; // 红色代表千早爱音
      } else if (characterId.value === 'muku') {
        characterName.value = '若叶睦';
        player.color = '#4ECDC4'; // 青色代表若叶睦
      } else {
        characterName.value = '未知角色';
        player.color = '#409EFF';
      }
    };
    
    // 角色图片对象
    const characterImages = reactive({
      chisato: null,
      muku: null
    });
    
    // 返回菜单
    const backToMenu = () => {
      router.push({ name: 'CharacterSelection' });
    };
    
    // 打开商店
    const openShop = () => {
      showShop.value = true;
      stopGameLoop(); // 暂停游戏
    };
    
    // 关闭商店
    const closeShop = (playerData) => {
      showShop.value = false;
      if (playerData) {
        gold.value = playerData.gold;
        player.level = playerData.level;
        player.exp = playerData.exp;
      }
      startGameLoop(); // 恢复游戏
    };
    
    // 处理购买
    const handlePurchase = (item) => {
      switch (item.effect) {
        case 'maxHp':
          playerMaxHp.value += item.value;
          playerHp.value = playerMaxHp.value;
          break;
        case 'speed':
          player.speed += item.value;
          break;
        case 'damage':
          player.damage += item.value;
          break;
        case 'fireRate':
          player.fireRate += item.value;
          break;
        case 'expBoost':
          // 这里可以设置一个经验加成标志，在获得经验时使用
          break;
        case 'goldBoost':
          // 这里可以设置一个金币加成标志，在获得金币时使用
          break;
      }
    };
    
    // 初始化画布
    const initCanvas = () => {
      if (gameCanvas.value) {
        ctx = gameCanvas.value.getContext('2d');
      }
    };
    
    // 绘制玩家
    const drawPlayer = () => {
      if (!ctx) return;
      
      // 根据角色ID选择图片
      let characterImage = null;
      if (characterId.value === 'chisato' && characterImages.chisato) {
        characterImage = characterImages.chisato;
      } else if (characterId.value === 'muku' && characterImages.muku) {
        characterImage = characterImages.muku;
      }
      
      // 如果图片已加载，绘制图片；否则绘制圆形
      if (characterImage) {
        // 计算图片绘制位置（使图片中心与玩家位置对齐）
        const imageX = player.x - player.radius;
        const imageY = player.y - player.radius;
        ctx.drawImage(characterImage, imageX, imageY, player.radius * 2, player.radius * 2);
      } else {
        // 绘制玩家圆形（作为后备方案）
        ctx.beginPath();
        ctx.arc(player.x, player.y, player.radius, 0, Math.PI * 2);
        ctx.fillStyle = player.color;
        ctx.fill();
        ctx.closePath();
        
        // 绘制玩家方向指示器
        ctx.beginPath();
        ctx.moveTo(player.x, player.y);
        ctx.lineTo(player.x + player.radius, player.y);
        ctx.strokeStyle = '#FFFFFF';
        ctx.lineWidth = 3;
        ctx.stroke();
        ctx.closePath();
      }
    };
    
    // 绘制敌人
    const drawEnemies = () => {
      enemies.forEach(enemy => {
        ctx.beginPath();
        ctx.arc(enemy.x, enemy.y, enemy.radius, 0, Math.PI * 2);
        ctx.fillStyle = enemy.color;
        ctx.fill();
        ctx.closePath();
      });
    };
    
    // 绘制子弹
    const drawBullets = () => {
      bullets.forEach(bullet => {
        ctx.beginPath();
        ctx.arc(bullet.x, bullet.y, bullet.radius, 0, Math.PI * 2);
        ctx.fillStyle = '#FFD700';
        ctx.fill();
        ctx.closePath();
      });
    };
    
    // 绘制道具
    const drawPowerUps = () => {
      powerUps.forEach(powerUp => {
        // 根据类型设置颜色
        let color = '#CCCCCC';
        let symbol = '?';
        
        switch (powerUp.type) {
          case 'health':
            color = '#FF6B6B';
            symbol = '❤️';
            break;
          case 'exp':
            color = '#4ECDC4';
            symbol = '⭐';
            break;
          case 'weapon':
            color = '#FFD700';
            symbol = '⚔️';
            break;
          case 'speed':
            color = '#6B5B95';
            symbol = '⚡';
            break;
          case 'multiplier':
            color = '#88D8B0';
            symbol = '✖️';
            break;
          case 'gold':
            color = '#FFD700';
            symbol = '💰';
            break;
        }
        
        // 绘制道具圆形
        ctx.beginPath();
        ctx.arc(powerUp.x, powerUp.y, powerUp.radius, 0, Math.PI * 2);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.closePath();
        
        // 绘制道具符号
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText(symbol, powerUp.x, powerUp.y);
      });
    };
    
    // 绘制血迹
    const drawBloodStains = () => {
      bloodStains.forEach(stain => {
        // 设置血迹颜色和透明度
        ctx.globalAlpha = stain.alpha;
        ctx.fillStyle = '#8B0000'; // 深红色
        
        // 绘制血迹圆形
        ctx.beginPath();
        ctx.arc(stain.x, stain.y, stain.radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.closePath();
        
        // 恢复全局透明度
        ctx.globalAlpha = 1.0;
      });
    };
    
    // 更新玩家位置（鼠标控制）
    const updatePlayerPosition = (mouseX, mouseY) => {
      // 计算方向向量
      const dx = mouseX - player.x;
      const dy = mouseY - player.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      // 如果距离大于速度，则移动
      if (distance > player.speed) {
        player.x += (dx / distance) * player.speed;
        player.y += (dy / distance) * player.speed;
      } else {
        // 如果很接近，直接设置位置
        player.x = mouseX;
        player.y = mouseY;
      }
      
      // 边界检查
      player.x = Math.max(player.radius, Math.min(800 - player.radius, player.x));
      player.y = Math.max(player.radius, Math.min(600 - player.radius, player.y));
    };
    
    // 生成敌人
    const spawnEnemy = () => {
      // 根据波次调整敌人数量和强度
      const enemyCount = Math.min(5 + wave.value, 20);
      
      // 只在敌人数量不足时生成
      if (enemies.length < enemyCount) {
        // 随机选择生成位置（屏幕边缘）
        const side = Math.floor(Math.random() * 4);
        let x, y;
        
        switch (side) {
          case 0: // 上边
            x = Math.random() * 800;
            y = -20;
            break;
          case 1: // 右边
            x = 820;
            y = Math.random() * 600;
            break;
          case 2: // 下边
            x = Math.random() * 800;
            y = 620;
            break;
          case 3: // 左边
            x = -20;
            y = Math.random() * 600;
            break;
        }
        
        // 创建敌人对象
        const enemy = {
          id: Date.now() + Math.random(), // 为敌人添加唯一ID
          x: x,
          y: y,
          radius: 15,
          speed: 1 + Math.random() * 1 + (wave.value * 0.1),
          color: '#FF4757',
          hp: 20 + wave.value * 5,
          maxHp: 20 + wave.value * 5,
          gold: 1 + Math.floor(wave.value / 2) // 敌人掉落的金币
        };
        
        enemies.push(enemy);
      }
    };
    
    // 更新敌人位置
    const updateEnemies = () => {
      for (let i = enemies.length - 1; i >= 0; i--) {
        const enemy = enemies[i];
        
        // 计算朝向玩家的方向
        const dx = player.x - enemy.x;
        const dy = player.y - enemy.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        // 移动敌人
        if (distance > 0) {
          enemy.x += (dx / distance) * enemy.speed;
          enemy.y += (dy / distance) * enemy.speed;
        }
        
        // 检查是否与玩家碰撞
        if (distance < player.radius + enemy.radius) {
          playerHp.value -= 1;
          // 移除敌人
          enemies.splice(i, 1);
          // 增加得分
          score.value += 10;
        }
      }
    };
    
    // 玩家自动攻击
    const playerAttack = () => {
      // 根据攻击速度判断是否发射子弹
      if (Math.random() < player.fireRate) {
        // 计算朝向最近的敌人的方向
        if (enemies.length > 0) {
          let closestEnemy = enemies[0];
          let closestDistance = Math.sqrt(
            Math.pow(player.x - closestEnemy.x, 2) + 
            Math.pow(player.y - closestEnemy.y, 2)
          );
          
          // 找到最近的敌人
          for (let i = 1; i < enemies.length; i++) {
            const enemy = enemies[i];
            const distance = Math.sqrt(
              Math.pow(player.x - enemy.x, 2) + 
              Math.pow(player.y - enemy.y, 2)
            );
            
            if (distance < closestDistance) {
              closestDistance = distance;
              closestEnemy = enemy;
            }
          }
          
          // 创建子弹，直接朝向最近的敌人
          const bullet = {
            x: player.x,
            y: player.y,
            radius: 5,
            speed: 10,
            targetId: closestEnemy.id || Date.now() // 使用敌人ID或时间戳作为目标标识
          };
          
          // 计算方向向量
          const dx = closestEnemy.x - bullet.x;
          const dy = closestEnemy.y - bullet.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          if (distance > 0) {
            bullet.dx = (dx / distance) * bullet.speed;
            bullet.dy = (dy / distance) * bullet.speed;
            
            bullets.push(bullet);
          }
        }
      }
    };
    
    // 更新子弹位置
    const updateBullets = () => {
      for (let i = bullets.length - 1; i >= 0; i--) {
        const bullet = bullets[i];
        
        // 如果子弹有目标ID，则尝试追踪目标
        if (bullet.targetId) {
          // 查找目标敌人
          const targetEnemy = enemies.find(enemy => enemy.id === bullet.targetId);
          
          // 如果目标存在，重新计算方向
          if (targetEnemy) {
            const dx = targetEnemy.x - bullet.x;
            const dy = targetEnemy.y - bullet.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            
            if (distance > 0) {
              bullet.dx = (dx / distance) * bullet.speed;
              bullet.dy = (dy / distance) * bullet.speed;
            }
          }
        }
        
        // 更新位置
        bullet.x += bullet.dx;
        bullet.y += bullet.dy;
        
        // 检查是否超出边界
        if (bullet.x < -50 || bullet.x > 850 || bullet.y < -50 || bullet.y > 650) {
          bullets.splice(i, 1);
          continue;
        }
        
        // 检查是否击中敌人
        for (let j = enemies.length - 1; j >= 0; j--) {
          const enemy = enemies[j];
          const distance = Math.sqrt(
            Math.pow(bullet.x - enemy.x, 2) + 
            Math.pow(bullet.y - enemy.y, 2)
          );
          
          if (distance < bullet.radius + enemy.radius) {
            // 击中敌人
            enemy.hp -= player.damage;
            bullets.splice(i, 1);
            
            // 检查敌人是否死亡
            if (enemy.hp <= 0) {
              // 生成血迹
              const bloodStain = {
                x: enemy.x,
                y: enemy.y,
                radius: enemy.radius,
                life: 120, // 血迹存在时间（帧数）
                maxLife: 120,
                alpha: 1.0
              };
              bloodStains.push(bloodStain);
              
              // 增加金币
              gold.value += enemy.gold;
              // 增加经验（根据波次调整）
              const expGain = Math.max(1, Math.floor(5 * (1 + wave.value * 0.1)));
              player.exp += expGain;
              // 检查是否升级
              if (player.exp >= expToNextLevel.value) {
                levelUp();
              }
              // 移除敌人
              enemies.splice(j, 1);
              // 增加得分
              score.value += 50;
            }
            
            break;
          }
        }
      }
    };
    
    // 生成道具
    const spawnPowerUp = () => {
      // 有一定概率生成道具
      if (Math.random() < 0.005) {
        // 道具类型
        const types = ['health', 'exp', 'weapon', 'speed', 'multiplier', 'gold'];
        const type = types[Math.floor(Math.random() * types.length)];
        
        // 随机位置
        const x = 50 + Math.random() * 700;
        const y = 50 + Math.random() * 500;
        
        // 创建道具对象
        const powerUp = {
          id: Date.now(), // 简单的ID生成方式
          x: x,
          y: y,
          type: type,
          radius: 15
        };
        
        powerUps.push(powerUp);
      }
    };
    
    // 更新道具
    const updatePowerUps = () => {
      for (let i = powerUps.length - 1; i >= 0; i--) {
        const powerUp = powerUps[i];
        
        // 检查是否与玩家碰撞
        const dx = player.x - powerUp.x;
        const dy = player.y - powerUp.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < player.radius + powerUp.radius) {
          // 应用道具效果
          applyPowerUpEffect(powerUp.type);
          
          // 移除道具
          powerUps.splice(i, 1);
        }
      }
    };
    
    // 更新血迹
    const updateBloodStains = () => {
      for (let i = bloodStains.length - 1; i >= 0; i--) {
        const stain = bloodStains[i];
        
        // 减少血迹的存在时间
        stain.life -= 1;
        
        // 更新血迹透明度
        stain.alpha = Math.max(0, stain.life / stain.maxLife);
        
        // 如果血迹存在时间结束，移除它
        if (stain.life <= 0) {
          bloodStains.splice(i, 1);
        }
      }
    };
    
    // 应用道具效果
    const applyPowerUpEffect = (type) => {
      switch (type) {
        case 'health':
          // 恢复生命值
          playerHp.value = Math.min(playerMaxHp.value, playerHp.value + 20);
          break;
        case 'exp':
          // 增加经验值
          const expGain = 10;
          player.exp += expGain;
          // 检查是否升级
          if (player.exp >= expToNextLevel.value) {
            levelUp();
          }
          break;
        case 'weapon':
          // 增加攻击力（这里简化为增加得分倍数）
          score.value += 100;
          break;
        case 'speed':
          // 增加移动速度
          player.speed = Math.min(10, player.speed + 0.5);
          break;
        case 'multiplier':
          // 增加得分倍数
          score.value = Math.floor(score.value * 1.2);
          break;
        case 'gold':
          // 增加金币
          gold.value += 5;
          break;
      }
    };
    
    // 波次管理
    const updateWave = () => {
      // 每隔一段时间增加波次
      if (score.value > wave.value * 500) {
        wave.value++;
      }
    };
    
    // 键盘控制状态
    const keys = reactive({
      ArrowUp: false,
      ArrowDown: false,
      ArrowLeft: false,
      ArrowRight: false
    });
    
    // 触摸控制状态
    const isTouching = ref(false);
    
    // 更新玩家位置（键盘控制）
    const updatePlayerPositionWithKeyboard = () => {
      // 根据按键状态移动玩家
      if (keys.ArrowUp) {
        player.y -= player.speed;
      }
      if (keys.ArrowDown) {
        player.y += player.speed;
      }
      if (keys.ArrowLeft) {
        player.x -= player.speed;
      }
      if (keys.ArrowRight) {
        player.x += player.speed;
      }
      
      // 边界检查
      player.x = Math.max(player.radius, Math.min(800 - player.radius, player.x));
      player.y = Math.max(player.radius, Math.min(600 - player.radius, player.y));
    };
    
    // 游戏循环
    let gameLoopId;
    
    const gameLoop = () => {
      if (!ctx) return;
      
      // 清空画布
      ctx.clearRect(0, 0, 800, 600);
      
      // 更新游戏对象
      // 只在没有使用触摸控制时更新键盘控制
      if (!isTouching.value) {
        updatePlayerPositionWithKeyboard();
      }
      spawnEnemy();
      updateEnemies();
      playerAttack();
      updateBullets();
      spawnPowerUp(); // 生成道具
      updatePowerUps(); // 更新道具
      updateBloodStains(); // 更新血迹
      updateWave();
      
      // 绘制游戏对象
      drawPowerUps(); // 绘制道具
      drawBullets();
      drawEnemies();
      drawBloodStains(); // 绘制血迹
      drawPlayer();
      
      // 检查游戏结束条件
      if (playerHp.value <= 0) {
        stopGameLoop();
        alert('游戏结束！最终得分：' + score.value + '，获得金币：' + gold.value);
        backToMenu();
      }
    };
    
    // 启动游戏循环
    const startGameLoop = () => {
      gameLoopId = setInterval(gameLoop, 1000 / 60); // 60 FPS
    };
    
    // 停止游戏循环
    const stopGameLoop = () => {
      if (gameLoopId) {
        clearInterval(gameLoopId);
      }
    };
    
    // 键盘按下事件处理
    const handleKeyDown = (e) => {
      if (e.key in keys) {
        keys[e.key] = true;
      }
    };
    
    // 键盘松开事件处理
    const handleKeyUp = (e) => {
      if (e.key in keys) {
        keys[e.key] = false;
      }
    };
    
    // 触摸开始事件处理
    const handleTouchStart = (e) => {
      // 防止触摸事件的默认行为（如滚动）
      e.preventDefault();
      isTouching.value = true;
    };
    
    // 触摸移动事件处理
    const handleTouchMove = (e) => {
      // 防止触摸事件的默认行为（如滚动）
      e.preventDefault();
      
      // 获取触摸点位置
      if (e.touches.length > 0) {
        const touch = e.touches[0];
        if (gameCanvas.value) {
          const rect = gameCanvas.value.getBoundingClientRect();
          const touchX = touch.clientX - rect.left;
          const touchY = touch.clientY - rect.top;
          
          // 计算方向向量
          const dx = touchX - player.x;
          const dy = touchY - player.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          
          // 如果距离大于速度，则移动
          if (distance > player.speed) {
            player.x += (dx / distance) * player.speed;
            player.y += (dy / distance) * player.speed;
          } else {
            // 如果很接近，直接设置位置
            player.x = touchX;
            player.y = touchY;
          }
          
          // 边界检查
          player.x = Math.max(player.radius, Math.min(800 - player.radius, player.x));
          player.y = Math.max(player.radius, Math.min(600 - player.radius, player.y));
        }
      }
    };
    
    // 触摸结束事件处理
    const handleTouchEnd = (e) => {
      // 防止触摸事件的默认行为
      e.preventDefault();
      isTouching.value = false;
    };
    
    // 组件挂载时
    onMounted(() => {
      setCharacterName();
      initCanvas();
      
      // 加载角色图片
      const loadCharacterImages = () => {
        // 加载千早爱音图片
        const chisatoImg = new Image();
        chisatoImg.src = chisatoImage;
        chisatoImg.onload = () => {
          characterImages.chisato = chisatoImg;
        };
        
        // 加载若叶睦图片
        const mukuImg = new Image();
        mukuImg.src = mukuImage;
        mukuImg.onload = () => {
          characterImages.muku = mukuImg;
        };
      };
      
      loadCharacterImages();
      startGameLoop();
      
      // 添加键盘事件监听器
      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('keyup', handleKeyUp);
      
      // 添加触摸事件监听器
      if (gameCanvas.value) {
        gameCanvas.value.addEventListener('touchstart', handleTouchStart, { passive: false });
        gameCanvas.value.addEventListener('touchmove', handleTouchMove, { passive: false });
        gameCanvas.value.addEventListener('touchend', handleTouchEnd, { passive: false });
      }
    });
    
    // 组件卸载时
    onUnmounted(() => {
      stopGameLoop();
      
      // 移除事件监听器
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      
      // 移除触摸事件监听器
      if (gameCanvas.value) {
        gameCanvas.value.removeEventListener('touchstart', handleTouchStart);
        gameCanvas.value.removeEventListener('touchmove', handleTouchMove);
        gameCanvas.value.removeEventListener('touchend', handleTouchEnd);
      }
    });
    
    return {
      characterName,
      wave,
      score,
      gold,
      player,
      playerHp,
      playerMaxHp,
      expToNextLevel,
      gameCanvas,
      showShop,
      backToMenu,
      openShop,
      closeShop,
      handlePurchase,
      characterImages,
      isTouching
    };
  }
};
</script>

<style scoped>
.game-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.game-info {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.game-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.game-canvas {
  width: 800px;
  height: 600px;
  border: 2px solid #ccc;
  margin-bottom: 20px;
}

.shop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.shop-modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}
</style>